import { motion } from "framer-motion";
import { ArrowRight, Clock3 } from "lucide-react";
import { ROOMS } from "@/lib/constants";
import { useLang } from "@/lib/i18n";

export const Rooms = () => {
  const { t } = useLang();
  const [checkInLabel, checkOutLabel] = t.rooms.noticeLead;
  const [checkInTime, checkOutRest] = t.rooms.notice.split("|");
  return (
    <section className="section" id="rooms">
      <div className="section-heading">
        <div>
          <div className="eyebrow">{t.rooms.eyebrow}</div>
          <h2>{t.rooms.title}</h2>
        </div>
        <p>{t.rooms.intro}</p>
      </div>
      <div className="room-grid">
        {ROOMS.map((room, index) => (
          <motion.article
            className={room.featured ? "room-card featured" : "room-card"}
            key={room.name}
            initial={{ opacity: 0, y: 28 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-60px" }}
            transition={{ duration: 0.6, delay: (index % 3) * 0.1, ease: [0.16, 1, 0.3, 1] }}
            data-testid={`room-card-${index + 1}`}
          >
            <div className="room-media">
              <img src={room.img} alt={`${room.name} — illustrative`} loading="lazy" />
              <span className="media-tag">{t.rooms.aiTag}</span>
            </div>
            <div className="room-card-body">
              <span className="card-tag">{t.rooms.tags[index]}</span>
              <h3>{t.rooms.names[index]}</h3>
              <div className="price">
                {room.price} <small>{t.rooms.onEnquiry}</small>
              </div>
              <p>{t.rooms.notes[index]}</p>
              <a href="#enquiry" className="text-link" data-testid={`room-select-${index + 1}`}>
                {t.rooms.enquire} <ArrowRight size={15} />
              </a>
            </div>
          </motion.article>
        ))}
      </div>
      <div className="notice" data-testid="checkin-notice">
        <Clock3 size={18} />
        <span>
          <strong>{checkInLabel}</strong> {checkInTime} &nbsp;·&nbsp; <strong>{checkOutLabel}</strong> {checkOutRest}
        </span>
      </div>
    </section>
  );
};
